import { getSecureItem } from "../src/utils/secureStorage";
export const getAge = (dateString) => {
    console.log('DATE STRING === ', dateString);

    try {
        console.log(
            '-------------------------- HELPER Function Start --------------------------'
        );
        const birthDate = new Date(dateString);
        console.log('helper.js - 5 - birthDate value : ', birthDate);
        const currentDate = new Date();
        console.log('helper.js - 10 - currentDate value : ', currentDate);

        if (isNaN(birthDate)) {
            // Check if the date is valid
            throw new Error('Invalid date format');
        }

        let age = currentDate.getFullYear() - birthDate.getFullYear();
        console.log('helper.js - 20 - age value : ', age);

        const monthDiff = currentDate.getMonth() - birthDate.getMonth();

        if (
            monthDiff < 0 ||
            (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())
        ) {
            age--;
            console.log('helper.js - 23 - IF - age value : ', age);
        }

        console.log('helper.js - 26 - before return - age value : ', age);
        console.log(
            '-------------------------- HELPER Function End --------------------------'
        );
        return age;
    } catch (error) {
        console.error('Error calculating age:', error.message);
        return null; // Or return a default value like -1, or throw the error if you prefer
    }
};

export const matchEmails = (email1, email2) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex

    if (!email1 || !email2) {
        return false;
    }

    const normalizedEmail1 = email1.trim().toLowerCase();
    const normalizedEmail2 = email2.trim().toLowerCase();

    // if (!emailRegex.test(normalizedEmail1) || !emailRegex.test(normalizedEmail2)) {
    //     return false; // Return false if either email is invalid
    // }

    return normalizedEmail1 === normalizedEmail2;
};
export const frenchFormatDate = (dateString) => {
    const months = {
        Jan: '01',
        Feb: '02',
        Mar: '03',
        Apr: '04',
        May: '05',
        Jun: '06',
        Jul: '07',
        Aug: '08',
        Sep: '09',
        Oct: '10',
        Nov: '11',
        Dec: '12',
    };

    const parts = dateString?.split(' ');
    if (parts?.length !== 3) {
        return 'Invalid date format'; // Or handle the error as you see fit
    }

    const day = parts[0].padStart(2, '0');
    const month = months[parts[1]];
    const year = parts[2];

    if (!month) {
        return 'Invalid month'; // Or handle the error as you see fit.
    }

    // return `${year}-${month}-${day}`;
    return `${day}-${month}-${year}`;
};
export const formatDate = (dateString) => {
    const months = {
        Jan: '01',
        Feb: '02',
        Mar: '03',
        Apr: '04',
        May: '05',
        Jun: '06',
        Jul: '07',
        Aug: '08',
        Sep: '09',
        Oct: '10',
        Nov: '11',
        Dec: '12',
    };

    const parts = dateString?.split(' ');
    if (parts?.length !== 3) {
        return 'Invalid date format'; // Or handle the error as you see fit
    }

    const day = parts[0].padStart(2, '0');
    const month = months[parts[1]];
    const year = parts[2];

    if (!month) {
        return 'Invalid month'; // Or handle the error as you see fit.
    }

    return `${year}-${month}-${day}`;
};
export const getTimeDifference = (dateTimeString) => {
    let lang = getSecureItem('i18nextLng');
    const inputDateTime = new Date(dateTimeString);
    const currentDateTime = new Date();

    const timeDifferenceMs = currentDateTime - inputDateTime;
    const timeDifferenceSeconds = Math.floor(timeDifferenceMs / 1000);
    const timeDifferenceMinutes = Math.floor(timeDifferenceSeconds / 60);
    const timeDifferenceHours = Math.floor(timeDifferenceMinutes / 60);
    const timeDifferenceDays = Math.floor(timeDifferenceHours / 24);

    if (timeDifferenceDays > 0) {
        let result;
        if (lang === 'fr') {
            result = `Il y a ${timeDifferenceDays} jour${
                timeDifferenceDays > 1 ? 's' : ''
            }`;
        } else {
            result = `Il y a ${timeDifferenceDays} jour${
                timeDifferenceDays > 1 ? 's' : ''
            }`;
        }
        return result;
    } else if (timeDifferenceHours > 0) {
        let result;
        if (lang === 'fr') {
            result = `Il y a ${timeDifferenceHours} heure${
                timeDifferenceHours > 1 ? 's' : ''
            }`;
        } else {
            result = `Il y a ${timeDifferenceHours} heure${
                timeDifferenceHours > 1 ? 's' : ''
            }`;
        }
        return result;
    } else if (timeDifferenceMinutes > 0) {
        let result;
        if (lang === 'fr') {
            result = `Il y a ${timeDifferenceMinutes} minute${
                timeDifferenceMinutes > 1 ? 's' : ''
            }`;
        } else {
             result = `Il y a ${timeDifferenceMinutes} minute${
                timeDifferenceMinutes > 1 ? 's' : ''
            }`;
        }
        return result;
    } else if (timeDifferenceSeconds > 0) {
        let result;
        if (lang === 'fr') {
            result = `Il y a ${timeDifferenceSeconds} seconde${
                timeDifferenceSeconds > 1 ? 's' : ''
            }`;
        } else {
            result = `Il y a ${timeDifferenceSeconds} seconde${
                timeDifferenceSeconds > 1 ? 's' : ''
            }`;
        }
        return result;
    } else {
        return lang == 'fr' ? 'A l’instant' : 'A l’instant';
    }
};

export const validatePassword = (password) => {
    if (!password) {
        return false;
    }

    if (password.length < 8) {
        return false;
    }

    if (!/[A-Z]/.test(password)) {
        return false;
    }

    if (!/[a-z]/.test(password)) {
        return false;
    }

    if (!/[@/?.…<>()\[\]\{\}|\\`~!#$%^&*=_+-]/.test(password)) {
        return false;
    }

    return true;
};

export const toCamelCase = (phrase) => {
    return phrase
        .toLowerCase() // Convert to lowercase
        .replace(/[^a-zA-Z0-9 ]/g, '') // Remove special characters
        .split(' ') // Split into words
        .map((word, index) =>
            index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
        ) // Capitalize first letter of each word except first
        .join(''); // Join words
};
